"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAgentEffort = exports.getAgentModelEfforts = exports.getAgentModel = exports.AGENT_MODEL_OPTIONS = exports.DEFAULT_AGENT_MODEL = exports.AGENT_MODEL_IDS = void 0;
exports.AGENT_MODEL_IDS = {
    astra: 'gpt-6-astra',
    fable51: 'fable-5.1',
    fable51Pi: 'fable-5.1-pi',
    glm53: 'z-ai/glm-5.3',
    opus55: 'opus-5.5',
    opus55Pi: 'opus-5.5-pi',
    sol: 'gpt-6.1-sol'
};
exports.DEFAULT_AGENT_MODEL = exports.AGENT_MODEL_IDS.opus55;
exports.AGENT_MODEL_OPTIONS = [
    {
        label: 'Opus 5.5',
        model: 'claude-opus-5-5',
        provider: 'anthropic',
        runtime: 'claude',
        value: exports.AGENT_MODEL_IDS.opus55
    },
    {
        label: 'Fable 5.1',
        model: 'claude-fable-5-1',
        provider: 'anthropic',
        runtime: 'claude',
        value: exports.AGENT_MODEL_IDS.fable51
    },
    {
        label: 'Opus 5.5 (Pi)',
        model: 'claude-opus-5-5',
        provider: 'anthropic',
        runtime: 'pi',
        value: exports.AGENT_MODEL_IDS.opus55Pi
    },
    {
        label: 'Fable 5.1 (Pi)',
        model: 'claude-fable-5-1',
        provider: 'anthropic',
        runtime: 'pi',
        value: exports.AGENT_MODEL_IDS.fable51Pi
    },
    { label: 'GPT-6.1 Sol', model: exports.AGENT_MODEL_IDS.sol, provider: 'openai', runtime: 'pi', value: exports.AGENT_MODEL_IDS.sol },
    {
        label: 'GPT-6 Astra',
        model: exports.AGENT_MODEL_IDS.astra,
        provider: 'openai',
        runtime: 'pi',
        value: exports.AGENT_MODEL_IDS.astra
    },
    {
        efforts: ['low', 'high', 'max'],
        label: 'GLM 5.3',
        model: exports.AGENT_MODEL_IDS.glm53,
        provider: 'openrouter',
        runtime: 'pi',
        value: exports.AGENT_MODEL_IDS.glm53
    }
];
// Accept previous Claude IDs for existing callers and saved model preferences.
const getAgentModel = (model) => exports.AGENT_MODEL_OPTIONS.find((option) => option.value === model || (option.runtime === 'claude' && option.model === model));
exports.getAgentModel = getAgentModel;
const DEFAULT_AGENT_EFFORTS = ['medium', 'high', 'max'];
const EFFORT_ORDER = ['low', 'medium', 'high', 'max'];
const getAgentModelEfforts = (model) => { var _a, _b; return (_b = (_a = (0, exports.getAgentModel)(model)) === null || _a === void 0 ? void 0 : _a.efforts) !== null && _b !== void 0 ? _b : DEFAULT_AGENT_EFFORTS; };
exports.getAgentModelEfforts = getAgentModelEfforts;
const normalizeAgentEffort = (model, effort) => {
    var _a;
    const efforts = (0, exports.getAgentModelEfforts)(model);
    if (efforts.includes(effort))
        return effort;
    const requested = EFFORT_ORDER.indexOf(effort);
    return (_a = efforts.find((candidate) => EFFORT_ORDER.indexOf(candidate) > requested)) !== null && _a !== void 0 ? _a : efforts[efforts.length - 1];
};
exports.normalizeAgentEffort = normalizeAgentEffort;
//# sourceMappingURL=agent-model.js.map